import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { Children, useEffect, useState } from "react";

export default function Option({
  categories,
  handleData,
  label,
  index,
  arabicLabel,
  fontStyle,
  field,
}) {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {console.log("the size :  ", windowDimensions)}
        {/* <h3 style={fontStyle}>{`:${arabicLabel}`}</h3> */}
      </div>

      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          fullWidth
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          label={label}
          onChange={(val) => handleData(val.target.value, field, index)}
        >
          {Children.toArray(
            categories.map((item) => (
              <MenuItem
                value={item}
                style={{ fontSize: windowDimensions.width < 500 ? 6 : null }}
              >
                {item}
              </MenuItem>
            ))
          )}
        </Select>
      </FormControl>
    </>
  );
}
